import { Pipe, PipeTransform, inject } from '@angular/core';
import { AuthService } from '@core/auth/services/auth-service';

@Pipe({
  name: 'hasAnyPermission',
  standalone: true
})
export class HasAnyPermissionPipe implements PipeTransform {
  private authService = inject(AuthService);

  transform(permissions: string[]): boolean {
    return this.authService.hasAnyPermission(permissions);
  }
}
